<div class="trix-text" [innerHTML]="text || 'Hier steht der Text, den die Kunden per eMail oder App erhalten.'"></div>
